import {Utils} from "./utils";
import {bbTimeZone} from "../utils/time_zone";

function convertTimeToMoment(date, time) {
    if (!date || !moment.isMoment(date) || !Utils.isNumber(time)) {
        return;
    }

    let datetime = moment(date);

    datetime = bbTimeZone.convertToCompany(datetime);

    const val = parseInt(time);
    const hours = parseInt(val / 60);
    const mins = val % 60;
    datetime.hour(hours);
    datetime.minutes(mins);
    datetime.seconds(0);

    datetime.year(date.year());
    datetime.month(date.month());
    datetime.date(date.date());

    return datetime;
}

function convertMomentToTime(datetime) {
    return bbTimeZone.convertToCompany(datetime).minutes() + bbTimeZone.convertToCompany(datetime).hours() * 60;
}

export {
    convertTimeToMoment,
    convertMomentToTime
}
